import { getPH, showLoginPopup, redirectAuth, } from '@media-platform/tool-auth/dist/utils';
const auth = () => (getPH() ? showLoginPopup() : redirectAuth());
export default auth;
